import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=43f51016&scoped=true&"
import script from "./ListaClientes.vue?vue&type=script&lang=js&"
export * from "./ListaClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f51016",
  null
  
)

export default component.exports